import { StateCreator } from 'zustand';

import { ActivityModuleSession, Activity } from '@/hooks/api/useCourseMode';

export interface CourseModeState {
  currentActivity: Activity | undefined;
  currentSession: ActivityModuleSession | undefined;
  currentModuleId: string | undefined;
  certificateAvailable: boolean;
  setCurrentActivity: (activity: Activity | undefined) => void;
  setCurrentSession: (session: ActivityModuleSession | undefined) => void;
  setCurrentModuleId: (moduleId: string | undefined) => void;
  setCertificateAvailable: (available: boolean) => void;
}

export const createCourseModeSlice: StateCreator<CourseModeState, [['zustand/devtools', never]]> = (
  set,
) => ({
  currentActivity: undefined,
  currentSession: undefined,
  currentModuleId: undefined,
  certificateAvailable: false,
  setCurrentActivity: (activity) =>
    set({ currentActivity: activity }, false, 'courseModeSlice/setCurrentActivity'),
  setCurrentSession: (session) =>
    set({ currentSession: session }, false, 'courseModeSlice/setCurrentSession'),
  setCurrentModuleId: (moduleId) =>
    set({ currentModuleId: moduleId }, false, 'courseModeSlice/setCurrentModuleId'),
  setCertificateAvailable: (available) =>
    set({ certificateAvailable: available }, false, 'courseModeSlice/setCertificateAvailable'),
});
